import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// https://api.themoviedb.org/3/movie/popular?api_key=<<api_key>>&language=en-US&page=1

// const tmdbApiKey = process.env.TMDB_KEY;
const page = 1;
export const tmdbApi = createApi({
  reducerPath: "tmdbApi",
  baseQuery: fetchBaseQuery({ baseUrl: "https://api.themoviedb.org/3" }),
  endpoints: (builder) => ({
    // Get Movies by type
    getMovies: builder.query({
      query: ({ genreIdOrCategoryName, page, searchQuery }) => {
        // Search Movie
        if (searchQuery) {
          return `/search/movie?query=${searchQuery}&page=${page}&api_key=${process.env.REACT_APP_TMDB_KEY}`;
        }

        if (
          genreIdOrCategoryName &&
          typeof genreIdOrCategoryName === "string"
        ) {
          // GEt Movies By Category
          return `/movie/${genreIdOrCategoryName}?page=${page}&api_key=${process.env.REACT_APP_TMDB_KEY}`;
        }

        if (
          genreIdOrCategoryName &&
          typeof genreIdOrCategoryName === "number"
        ) {
          // Get Movies By Genre
          return `discover/movie?with_genres=${genreIdOrCategoryName}&page=${page}&api_key=${process.env.REACT_APP_TMDB_KEY}`;
        }

        // GEt Popular Movies
        return `/movie/popular?page=${page}&api_key=${process.env.REACT_APP_TMDB_KEY}`;
      },
    }),

    // Get User Specific List
    getList: builder.query({
      query: ({ listName, accountId, sessionId, page }) =>
        `/account/${accountId}/${listName}?api_key=${process.env.REACT_APP_TMDB_KEY}&session_id=${sessionId}&page=${page}`,
    }),

    // get Movie
    getMovie: builder.query({
      query: (id) =>
        `/movie/${id}?append_to_response=videos,credits&api_key=${process.env.REACT_APP_TMDB_KEY}`,
    }),

    //Get Movies by Geners
    getGenres: builder.query({
      query: () => `genre/movie/list?api_key=${process.env.REACT_APP_TMDB_KEY}`,
    }),

    //Get User Specific Movie
    getRecommentation: builder.query({
      query: ({ id, page }) =>
        `/discover/movie?with_cast=${id}&page=${page}&api_key=${process.env.REACT_APP_TMDB_KEY}`,
    }),

    // Get Actor Details
    getActorDetail: builder.query({
      query: (id) => `/person/${id}?api_key=${process.env.REACT_APP_TMDB_KEY}`,
    }),

    // Get Movies By Actor Id
    getMoviesByActorId: builder.query({
      query: ({ id, page }) =>
        `discover/movie?with_cast=${id}&page=${page}&api_key=${process.env.REACT_APP_TMDB_KEY}`,
    }),
  }),
});
export const {
  useGetMoviesQuery,
  useGetGenresQuery,
  useGetMovieQuery,
  useGetRecommentationQuery,
  useGetActorDetailQuery,
  useGetMoviesByActorIdQuery,
  useGetListQuery,
} = tmdbApi;
